import type { ReactNode } from 'react';
import styles from './Layout.module.css';
import { Header } from './Header';
import { Footer } from './Footer';

// 背景画像は lib/web(@zenid/web) 配信の zenid_bg.png を利用。mypage-web と同じ背景定義（cover / repeat-y）。
const BACKGROUND_IMAGE = `url(${import.meta.env.VITE_ASSETS_URL}/assets/images/zenid_bg.png)`;

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.layout} style={{ backgroundImage: BACKGROUND_IMAGE }}>
      <Header />
      <main className={styles.main}>{children}</main>
      <Footer />
    </div>
  );
}
